<template>
    <Dropdown
        @click="isOpen = !isOpen"
        :show="isOpen"
    >
        <template #content>
            <span class="hidden md:block text-gray-700">
                {{ authUser.firstName }}
            </span>
            <Image
                class="rounded-full w-8 h-8 object-cover"
                :src="authUser.getProfilePictureUrlWithFallback()"
            />
        </template>
        <template #items>
            <a
                v-if="authCompanyUser.isAdminOrOwner()"
                :href="RoutePathAppEnum.Company"
            >
                <DropdownItem>Company</DropdownItem>
            </a>
            <a :href="RoutePathAppEnum.MyProfile">
                <DropdownItem>My Profile</DropdownItem>
            </a>
            <a
                v-if="authUser.admin"
                :href="RoutePathAppEnum.Admin_Users"
            >
                <DropdownItem>Users</DropdownItem>
            </a>
            <DropdownItem
                v-if="impersonating"
                @click="leaveImpersonateApiFormRef?.submit()"
            >
                Leave Impersonate
            </DropdownItem>
            <DropdownItem @click="logoutApiFormRef?.submit()">
                Logout
            </DropdownItem>
            <ApiForm
                :url="RoutePathAppEnum.Admin_Users_LeaveImpersonateMode"
                method="POST"
                ref="leaveImpersonateApiFormRef"
            />
            <ApiForm
                :url="RoutePathAppEnum.Auth_Logout"
                method="POST"
                ref="logoutApiFormRef"
            />
        </template>
    </Dropdown>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import Dropdown from '@/Shared/Component/Dropdown.vue'
    import DropdownItem from '@/Shared/Component/DropdownItem.vue'
    import User from '@/App/User/Entity/User'
    import CompanyUser from '@/App/CompanyUser/Entity/CompanyUser'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'
    import Image from '@/Shared/Component/Image.vue'

    interface ProfileDropdownProps {
        authUser: User
        authCompanyUser: CompanyUser
        impersonating: boolean
    }

    const props = defineProps<ProfileDropdownProps>()
    const isOpen = ref<boolean>(false)
    const leaveImpersonateApiFormRef = ref<ApiFormRefType>(null)
    const logoutApiFormRef = ref<ApiFormRefType>(null)
</script>
